import { AnyAction } from 'redux'

export { default as actions } from './actions'

export enum MessagingTypes {
  UPDATE_HAS_UNREAD_MESSAGE = 'UPDATE_HAS_UNREAD_MESSAGE',
  NONE = '',
}

export interface MessagingState {
  hasUnreadMessage?: boolean
  unreadMessageCount?: number
}

// NPM library is as
const INITIAL_STATE: MessagingState = {
  hasUnreadMessage: false,
  unreadMessageCount: 0,
}

const messaging = (
  state = INITIAL_STATE,
  action: AnyAction = {
    type: MessagingTypes.NONE,
    payload: {
      hasUnreadMessage: false,
      unreadMessageCount: 0,
    },
  },
) => {
  switch (action.type) {
    case MessagingTypes.UPDATE_HAS_UNREAD_MESSAGE:
      // Temporary fix, direct messages returning wrong state.  This should be removed once npm library is updated.
      if (typeof action.payload === 'boolean') {
        return {
          ...state,
          hasUnreadMessage: action.payload,
          unreadMessageCount: action.payload ? state.unreadMessageCount : 0,
        }
      }
      return {
        ...state,
        unreadMessageCount: action.payload.unreadMessageCount ?? state.unreadMessageCount,
        hasUnreadMessage: action.payload.hasUnreadMessage ?? state.hasUnreadMessage,
      }
    default:
      return state
  }
}

export default messaging
